import { HomeController } from './home.controller'

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('home', {
      url: '/home',
      views: {
        '': {
          templateUrl: '/home/home.html?$$REVISION$$',
          controller: HomeController
        }
      },
      onEnter: ($rootScope, $stateParams, $state) => {
        const checkAccess = async () => {
          const featurePlan = await $rootScope.getCompanyFeaturesAndAddons()
          const isHomeDisabled = featurePlan.pricingPackageId === 4
          if (isHomeDisabled) $state.go('workflow', $stateParams, { reload: true })
          if ($rootScope.isUser()) {
            const hasArtAccess = featurePlan.features['ARTS.ACCESS']
            const moduleToGo = hasArtAccess ? 'user.arts' : 'workflow'
            $state.go(moduleToGo, $stateParams, { reload: true })
          }
        }
        checkAccess()
      }
    })

  $urlRouterProvider.when('/home/', '/home')
}

export const homeRoutes = routes
